var Computed, ComputedArray, Observable, ObservableArray, ko;

if (typeof require !== "undefined" && require !== null) {
  ko = require('../../../knockout/build/output/knockout-latest.debug');
}

Observable = function(self, property, initial_value) {
  if (initial_value === void 0) {
    initial_value = self[property];
  }
  return self[property] = ko.observable(initial_value);
};

ObservableArray = function(self, property, initial_value) {
  if (initial_value === void 0) {
    initial_value = [];
  }
  self[property] = ko.observableArray(initial_value);
  self[property].select = function(fn) {
    return ko.utils.arrayFilter(self[property].call(), fn);
  };
  return self[property].map = function(fn) {
    return ko.utils.arrayMap(self[property].call(), fn);
  };
};

Computed = function(self, property, fn) {
  return self[property] = ko.computed(fn);
};

ComputedArray = function(self, property, fn) {
  var actual_property, property_fn;
  actual_property = '_actual_' + property;
  property_fn = '_' + property;
  ObservableArray(self, actual_property);
  self[property_fn] = (function(_this) {
    return function() {
      self[actual_property](fn());
      return self[actual_property]();
    };
  })(this);
  return self[property] = ko.computed(self[property_fn]);
};

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    Observable: Observable,
    ObservableArray: ObservableArray,
    Computed: Computed,
    ComputedArray: ComputedArray
  };
}

//# sourceMappingURL=observable.js.map
